import React from 'react';
import { checkToken } from '../../../services/request.service'

class Popup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
        this.closePopup = this.closePopup.bind(this);
        this.logOut = this.logOut.bind(this);
    }

    closePopup() {
        checkToken()
            .then(this.props.togglePopup());
    }

    logOut() {
        this.props.logOut();
        this.props.togglePopup();
    }

    componentDidMount() {
        if (this.props.isIdle) {
            this.timerHandle = setTimeout(() => {
                this.props.logOut();
                this.props.togglePopup();
                this.timerHandle = 0
            }, 60000 * 15);
        }
    }

    componentWillUnmount = () => {
        if (this.timerHandle) {
            clearTimeout(this.timerHandle);
            this.timerHandle = 0;
        }
    };

    render() {
        return (
            <div className='popup'>
                <div className='popup-inner merge idle'>
                    <div className='header'>
                        <div className='title'>Alert!</div>
                        <button onClick={this.closePopup} className="close-cross" aria-label="close modal" />
                    </div>
                    <p>{this.props.text}</p>
                    <label>It looks like you have been away and you are about to time out.</label>
                    <div>
                        <button className="button primary" onClick={this.closePopup} style={{ marginRight: '10px' }}>Yes</button>
                        <button className="button secondary" onClick={this.logOut}>No</button>
                    </div>
                    {/*this.props.deletionWarning &&
                        <div>
                        <button className="button primary" onClick={this.props.togglePopup}>Continue</button>
                            <button className="button secondary" onClick={this.props.logOut}>Cancel</button>
                        </div>
                    */}
                </div>
            </div>
        );
    }
}

export default Popup;

export const HistoricalRedirectPopup = (props) => {

    return <div className='popup' onClick={props.closePopup}>
        <div className='popup-inner redirect' onClick={e => e.stopPropagation()}>
            <div className='header'>
                <div className='title'>Alert!</div>
                <button onClick={props.closePopup} className="close-cross" aria-label="close modal" />
            </div>
            <p>For historical data, please use <b>Legacy LIS</b>, available at <b><a href="https://legacylis.virginia.gov" target="_blank" rel="noreferrer">https://legacylis.virginia.gov</a></b>.</p>
            <p>Click 'Go' to be taken to Legacy LIS, or close this popup to remain here.</p>
            <div className="inline-list">
                <button className="button primary float-right" onClick={props.redirect}>Go</button>
            </div>
        </div>
    </div>
}
